import { HrefLangAlternate } from '@app/services/href-lang-service'

export const getLinkFromHrefLang = (urlOrPath: string): string => {
  const isUrl = /(http(s?)):\/\//i.test(urlOrPath)
  if (isUrl) {
    return urlOrPath
  }

  return `${process.env.NEXT_PUBLIC_BASE_URL}${urlOrPath}`
}

export const stringToObject = (separator: string, value: string) =>
  value.split(separator).map((item: string) => item.trim())

export const getHrefLangTags = ({
  hreflangOverrides,
  availableCountries,
  hrefLangAlternates,
}: {
  hreflangOverrides: string
  availableCountries: string[]
  hrefLangAlternates: HrefLangAlternate[]
}) => {
  // hrefLangAlternates comes from the plugin iz-href-alternates
  // It has the strongest weight so it should return that value if exists
  if (hrefLangAlternates && hrefLangAlternates?.length > 0) {
    return hrefLangAlternates
  }

  // hreflangOverrides comes from a field added temporarily to improve hreflangs on help-center
  // This should be removed after migrated fully to use the plugin instead
  if (hreflangOverrides?.length > 0) {
    return stringToObject(',', hreflangOverrides)
  }

  // availableCountries are the countries where that article is supported
  // This is a default behavior that will automatically add the hreflangs
  return availableCountries
}
